export const namespaced = true;

export const state = {
    barriers: [],
    types: [],
    type: null,
    sort: null,
    barrier: {},
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_BARRIERS(state, barriers) {
        state.barriers = barriers;
    },
    FETCH_TYPES(state, types) {
        state.types = types;
    },
    FETCH_BARRIER(state, barrier) {
        state.barrier = barrier;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    ADD_BARRIER(state, barrier) {
        state.barriers.unshift(barrier);
    },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_TYPE(state, type) {
        state.type = type;
    },
    SET_SORT(state, sort) {
        state.sort = sort;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    BARRIERS_REMOVE(state) { },
    BARRIERS_BLOCK(state) { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {

        const params = {
            page: state.page,
            type: state.type,
            per_page: state.per_page
        };

        if (state.sort) {
            params['sort'] = state.sort.value;
            if (state.sort.desc) {
                params['desc'] = 1;
            }
        }

        try {
            const res = (await axios.get(`/api/admin/barriers`, {
                params
            })).data;
            commit('FETCH_BARRIERS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchBarrier({ commit, state, dispatch }, barrier_id) {
        try {
            const res = (await axios.get(`/api/admin/barriers/${barrier_id}`)).data;
            commit('FETCH_BARRIER', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchTypes({ commit, state, dispatch }) {

        try {
            const res = (await axios.get(`/api/admin/barriers-types`)).data;
            commit('FETCH_TYPES', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
    },

    setType({ commit, state, dispatch }, type) {
        commit('SET_PAGE', 1);
        commit('SET_TYPE', type);
    },

    setSort({ commit, state, dispatch }, sort) {
        commit('SET_PAGE', 1);
        commit('SET_SORT', sort);
    },

    async copy({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('copies[]', i);
                }

                await axios.post(
                    `/api/admin/copy-barriers`, formDataPost
                );

                dispatch('fetch');

                const notification = {
                    type: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    type: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                element: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async copySingle({ commit, state, dispatch }, elementId) {

        try {
            const res = await axios.post(`/api/admin/copy-barrier/${elementId}`);

            const notification = {
                type: "success",
                message: "Копирование успешно выполнено",
            };
            dispatch("notification/add", notification, { root: true });

            return res.data.data;

        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true });
            throw error;
        }
    },

    async block({ commit, state, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-barriers`, formDataPost
                    )
                ).data;
                commit('BARRIERS_BLOCK');
                dispatch('fetch');
                dispatch('types/fetch', {}, { root: true });
                const notification = {
                    barrier: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    barrier: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                type: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', parseInt(i));
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-barriers`, formDataPost
                    )
                ).data;
                commit('BARRIERS_REMOVE');

                dispatch('fetch');
                dispatch('types/fetch', {}, { root: true });

                const notification = {
                    barrier: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    barrier: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                type: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },
}
